import { useMutation } from "react-query";
import { deleteAwsFile, uploadFile } from "api/services/storage";
import { snack } from "components/toast";
import { removeOneDriveFile } from "api/services/onedrive";

const useFileUpload = () => {
    const { mutate: deleteFile, isLoading: deleting } = useMutation(removeOneDriveFile, {
        onSuccess: () => {

        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const { mutate: deleteAwsFiles, isLoading: deletingAwsFile } = useMutation(deleteAwsFile, {
        onSuccess: () => {

        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    })

    const { mutateAsync: uploadFileAsync, isLoading: uploading } = useMutation(uploadFile, {
        onSuccess: (res) => {

        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });
    const handleFileUpload = async (file) => {

        const response = await uploadFileAsync(file);
        
        return { ...response?.data, type: 'organization', show: false };

    };
    return { handleFileUpload, uploading, deleteFile, deleteAwsFiles, deleting, deletingAwsFile };
};

export default useFileUpload;
